var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subpage__cnt col-xl-10 offset-xl-1 text-center"},[_c('ListPageHeaderNoLine2',{attrs:{"page-info":_vm.pageInfo}}),_c('div',{staticClass:"subpage-list uni-search-wrp"},[_c('Hero',{attrs:{"filter-dorm":false}})],1),_c('FeaturedDormsNoTabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }